<template>
<div class="container pt-5 mb-5">
  <div class="row justify-content-center">
    <div class="col-md-8">
      <div class="form-group">
        <label for="new-category">New Category</label>
        <input type="text" class="form-control" id="new-category" name="new-category" placeholder="Category Name" autocomplete="nope" v-validate="'required'" v-model="categoryName">
      </div>
      <div class="alert alert-warning alert-dismissible fade show mt-4 mb-4" role="alert" v-show="errors.has('new-category')">
        <strong>{{ errors.first('new-category') }}</strong>
      </div>

      <label for="new-category">Background Category</label>
      <div class="c-upload">
        <input type="file" class="c-upload__input-file" name="file" @change="changeFile" v-validate="'required|ext:jpg,png,jpeg'">
        <div class="c-upload__content">
          <font-awesome-icon class="c-upload__icon" :icon="['fal', 'upload']"></font-awesome-icon>
          <h4 class="c-upload__text mt-4">{{ title }}</h4>
        </div>
      </div>
      <div class="alert alert-warning alert-dismissible fade show mt-4" role="alert" v-show="errors.has('file')">
        <strong>{{ errors.first('file') }}</strong>
      </div>

      <div class="progress mt-4" v-if="loader">
        <div class="progress-bar progress-bar-striped progress-bar-animated bg-primary" role="progressbar" :style="{width: progress + '%'}" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"></div>
      </div>

      <button class="btn btn-block btn-primary mt-4" @click.prevent="uploadFile()">Add Category</button>
    </div>
  </div>
</div>
</template>

<script>
  import { categories, storageFiles } from '../../firebase'
  import { busNotifications } from '../../bus'

  export default {
    data() {
      return {
        categoryName: '',
        title: 'Upload Image',
        file: [],
        fileName: '',
        loader: false,
        progress: 0,
        numberCategories: 0
      }
    },
    mounted() {
      categories.onSnapshot( querySnapshot => {
        this.numberCategories = querySnapshot.docs.length
      })
    },
    methods: {
      split(value) {
        let map = {
          "À": "A",
          "Á": "A",
          "Â": "A",
          "Ã": "A",
          "Ä": "A",
          "Å": "A",
          "Æ": "AE",
          "Ç": "C",
          "È": "E",
          "É": "E",
          "Ê": "E",
          "Ë": "E",
          "Ì": "I",
          "Í": "I",
          "Î": "I",
          "Ï": "I",
          "Ð": "D",
          "Ñ": "N",
          "Ò": "O",
          "Ó": "O",
          "Ô": "O",
          "Õ": "O",
          "Ö": "O",
          "Ø": "O",
          "Ù": "U",
          "Ú": "U",
          "Û": "U",
          "Ü": "U",
          "Ý": "Y",
          "ß": "s",
          "à": "a",
          "á": "a",
          "â": "a",
          "ã": "a",
          "ä": "a",
          "å": "a",
          "æ": "ae",
          "ç": "c",
          "è": "e",
          "é": "e",
          "ê": "e",
          "ë": "e",
          "ì": "i",
          "í": "i",
          "î": "i",
          "ï": "i",
          "ñ": "n",
          "ò": "o",
          "ó": "o",
          "ô": "o",
          "õ": "o",
          "ö": "o",
          "ø": "o",
          "ù": "u",
          "ú": "u",
          "û": "u",
          "ü": "u",
          "ý": "y",
          "ÿ": "y",
          "Ā": "A",
          "ā": "a",
          "Ă": "A",
          "ă": "a",
          "Ą": "A",
          "ą": "a",
          "Ć": "C",
          "ć": "c",
          "Ĉ": "C",
          "ĉ": "c",
          "Ċ": "C",
          "ċ": "c",
          "Č": "C",
          "č": "c",
          "Ď": "D",
          "ď": "d",
          "Đ": "D",
          "đ": "d",
          "Ē": "E",
          "ē": "e",
          "Ĕ": "E",
          "ĕ": "e",
          "Ė": "E",
          "ė": "e",
          "Ę": "E",
          "ę": "e",
          "Ě": "E",
          "ě": "e",
          "Ĝ": "G",
          "ĝ": "g",
          "Ğ": "G",
          "ğ": "g",
          "Ġ": "G",
          "ġ": "g",
          "Ģ": "G",
          "ģ": "g",
          "Ĥ": "H",
          "ĥ": "h",
          "Ħ": "H",
          "ħ": "h",
          "Ĩ": "I",
          "ĩ": "i",
          "Ī": "I",
          "ī": "i",
          "Ĭ": "I",
          "ĭ": "i",
          "Į": "I",
          "į": "i",
          "İ": "I",
          "ı": "i",
          "Ĳ": "IJ",
          "ĳ": "ij",
          "Ĵ": "J",
          "ĵ": "j",
          "Ķ": "K",
          "ķ": "k",
          "Ĺ": "L",
          "ĺ": "l",
          "Ļ": "L",
          "ļ": "l",
          "Ľ": "L",
          "ľ": "l",
          "Ŀ": "L",
          "ŀ": "l",
          "Ł": "l",
          "ł": "l",
          "Ń": "N",
          "ń": "n",
          "Ņ": "N",
          "ņ": "n",
          "Ň": "N",
          "ň": "n",
          "ŉ": "n",
          "Ō": "O",
          "ō": "o",
          "Ŏ": "O",
          "ŏ": "o",
          "Ő": "O",
          "ő": "o",
          "Œ": "OE",
          "œ": "oe",
          "Ŕ": "R",
          "ŕ": "r",
          "Ŗ": "R",
          "ŗ": "r",
          "Ř": "R",
          "ř": "r",
          "Ś": "S",
          "ś": "s",
          "Ŝ": "S",
          "ŝ": "s",
          "Ş": "S",
          "ş": "s",
          "Š": "S",
          "š": "s",
          "Ţ": "T",
          "ţ": "t",
          "Ť": "T",
          "ť": "t",
          "Ŧ": "T",
          "ŧ": "t",
          "Ũ": "U",
          "ũ": "u",
          "Ū": "U",
          "ū": "u",
          "Ŭ": "U",
          "ŭ": "u",
          "Ů": "U",
          "ů": "u",
          "Ű": "U",
          "ű": "u",
          "Ų": "U",
          "ų": "u",
          "Ŵ": "W",
          "ŵ": "w",
          "Ŷ": "Y",
          "ŷ": "y",
          "Ÿ": "Y",
          "Ź": "Z",
          "ź": "z",
          "Ż": "Z",
          "ż": "z",
          "Ž": "Z",
          "ž": "z",
          "ſ": "s",
          "ƒ": "f",
          "Ơ": "O",
          "ơ": "o",
          "Ư": "U",
          "ư": "u",
          "Ǎ": "A",
          "ǎ": "a",
          "Ǐ": "I",
          "ǐ": "i",
          "Ǒ": "O",
          "ǒ": "o",
          "Ǔ": "U",
          "ǔ": "u",
          "Ǖ": "U",
          "ǖ": "u",
          "Ǘ": "U",
          "ǘ": "u",
          "Ǚ": "U",
          "ǚ": "u",
          "Ǜ": "U",
          "ǜ": "u",
          "Ǻ": "A",
          "ǻ": "a",
          "Ǽ": "AE",
          "ǽ": "ae",
          "Ǿ": "O",
          "ǿ": "o"},
        nonWord = /\W/g,
        mapping = c => {
          return map[c] || c;
        };
        return value.replace(nonWord, mapping).toLowerCase().split(/\s/).join('-').split("'").join('-')
      },

      changeFile(event) {
        this.title = event.target.files[0].name
        this.file = event.target.files[0]
      },
      uploadFile() {
        this.$validator.validate().then( res => {
          if(res) {
            const uploadTask = storageFiles.child('public/thumbnails/' + this.title).put(this.file)

            uploadTask.on( 'state_changed', snapshot => {
              let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
              this.progress = progress;
              this.loader = true;

              if( progress >= 100 ) {
                this.loader = false
              }
            },
            error => {
              console.log(error)
            },
            () => {
              uploadTask.snapshot.ref.getDownloadURL().then( downloadURL => {

                const slug = this.split(this.categoryName)
                const category = {
                  name: this.categoryName,
                  slug: slug,
                  priority: this.numberCategories + 1,
                  background: downloadURL,
                  backgroundName: this.title
                }
                categories.doc(slug).set(category);

                this.title = 'Upload File';
                this.categoryName = '';
                this.fileName = '';
                this.$validator.reset();
                this.errors.clear();
								busNotifications.makeNotification('success', 'The category has been added correctly')
              })
            })
          }
        })
      }
    },
    filters: {
      split(value) {
        let map = {
            "À": "A",
            "Á": "A",
            "Â": "A",
            "Ã": "A",
            "Ä": "A",
            "Å": "A",
            "Æ": "AE",
            "Ç": "C",
            "È": "E",
            "É": "E",
            "Ê": "E",
            "Ë": "E",
            "Ì": "I",
            "Í": "I",
            "Î": "I",
            "Ï": "I",
            "Ð": "D",
            "Ñ": "N",
            "Ò": "O",
            "Ó": "O",
            "Ô": "O",
            "Õ": "O",
            "Ö": "O",
            "Ø": "O",
            "Ù": "U",
            "Ú": "U",
            "Û": "U",
            "Ü": "U",
            "Ý": "Y",
            "ß": "s",
            "à": "a",
            "á": "a",
            "â": "a",
            "ã": "a",
            "ä": "a",
            "å": "a",
            "æ": "ae",
            "ç": "c",
            "è": "e",
            "é": "e",
            "ê": "e",
            "ë": "e",
            "ì": "i",
            "í": "i",
            "î": "i",
            "ï": "i",
            "ñ": "n",
            "ò": "o",
            "ó": "o",
            "ô": "o",
            "õ": "o",
            "ö": "o",
            "ø": "o",
            "ù": "u",
            "ú": "u",
            "û": "u",
            "ü": "u",
            "ý": "y",
            "ÿ": "y",
            "Ā": "A",
            "ā": "a",
            "Ă": "A",
            "ă": "a",
            "Ą": "A",
            "ą": "a",
            "Ć": "C",
            "ć": "c",
            "Ĉ": "C",
            "ĉ": "c",
            "Ċ": "C",
            "ċ": "c",
            "Č": "C",
            "č": "c",
            "Ď": "D",
            "ď": "d",
            "Đ": "D",
            "đ": "d",
            "Ē": "E",
            "ē": "e",
            "Ĕ": "E",
            "ĕ": "e",
            "Ė": "E",
            "ė": "e",
            "Ę": "E",
            "ę": "e",
            "Ě": "E",
            "ě": "e",
            "Ĝ": "G",
            "ĝ": "g",
            "Ğ": "G",
            "ğ": "g",
            "Ġ": "G",
            "ġ": "g",
            "Ģ": "G",
            "ģ": "g",
            "Ĥ": "H",
            "ĥ": "h",
            "Ħ": "H",
            "ħ": "h",
            "Ĩ": "I",
            "ĩ": "i",
            "Ī": "I",
            "ī": "i",
            "Ĭ": "I",
            "ĭ": "i",
            "Į": "I",
            "į": "i",
            "İ": "I",
            "ı": "i",
            "Ĳ": "IJ",
            "ĳ": "ij",
            "Ĵ": "J",
            "ĵ": "j",
            "Ķ": "K",
            "ķ": "k",
            "Ĺ": "L",
            "ĺ": "l",
            "Ļ": "L",
            "ļ": "l",
            "Ľ": "L",
            "ľ": "l",
            "Ŀ": "L",
            "ŀ": "l",
            "Ł": "l",
            "ł": "l",
            "Ń": "N",
            "ń": "n",
            "Ņ": "N",
            "ņ": "n",
            "Ň": "N",
            "ň": "n",
            "ŉ": "n",
            "Ō": "O",
            "ō": "o",
            "Ŏ": "O",
            "ŏ": "o",
            "Ő": "O",
            "ő": "o",
            "Œ": "OE",
            "œ": "oe",
            "Ŕ": "R",
            "ŕ": "r",
            "Ŗ": "R",
            "ŗ": "r",
            "Ř": "R",
            "ř": "r",
            "Ś": "S",
            "ś": "s",
            "Ŝ": "S",
            "ŝ": "s",
            "Ş": "S",
            "ş": "s",
            "Š": "S",
            "š": "s",
            "Ţ": "T",
            "ţ": "t",
            "Ť": "T",
            "ť": "t",
            "Ŧ": "T",
            "ŧ": "t",
            "Ũ": "U",
            "ũ": "u",
            "Ū": "U",
            "ū": "u",
            "Ŭ": "U",
            "ŭ": "u",
            "Ů": "U",
            "ů": "u",
            "Ű": "U",
            "ű": "u",
            "Ų": "U",
            "ų": "u",
            "Ŵ": "W",
            "ŵ": "w",
            "Ŷ": "Y",
            "ŷ": "y",
            "Ÿ": "Y",
            "Ź": "Z",
            "ź": "z",
            "Ż": "Z",
            "ż": "z",
            "Ž": "Z",
            "ž": "z",
            "ſ": "s",
            "ƒ": "f",
            "Ơ": "O",
            "ơ": "o",
            "Ư": "U",
            "ư": "u",
            "Ǎ": "A",
            "ǎ": "a",
            "Ǐ": "I",
            "ǐ": "i",
            "Ǒ": "O",
            "ǒ": "o",
            "Ǔ": "U",
            "ǔ": "u",
            "Ǖ": "U",
            "ǖ": "u",
            "Ǘ": "U",
            "ǘ": "u",
            "Ǚ": "U",
            "ǚ": "u",
            "Ǜ": "U",
            "ǜ": "u",
            "Ǻ": "A",
            "ǻ": "a",
            "Ǽ": "AE",
            "ǽ": "ae",
            "Ǿ": "O",
            "ǿ": "o"},
          nonWord = /\W/g,
          mapping = c => {
            return map[c] || c;
          };
        return value.replace(nonWord, mapping).toLowerCase().split(/\s/).join('-').split("'").join('-')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/admin/AddCategory.vue